import { render } from "./image-profile-change.vue?vue&type=template&id=d6a373a2"
import script from "./image-profile-change.vue?vue&type=script&lang=js"
export * from "./image-profile-change.vue?vue&type=script&lang=js"

import "./image-profile-change.vue?vue&type=style&index=0&id=d6a373a2&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__